import { api } from "./client";
import { withDeadline } from "./deadline";
import { apiError } from "./errors";
import type { components, operations } from "./schema";

export type FieldLeadCreate = components["schemas"]["FieldLeadCreate"];
export type FieldLeadRead = components["schemas"]["FieldLeadRead"];
export type FieldMachineOption = components["schemas"]["FieldMachineOption"];
type FieldMachinePage = components["schemas"]["Page_FieldMachineOption_"];

type FieldMachineListParams = NonNullable<
  operations["list_machines_field_leads_machines_get"]["parameters"]["query"]
>;

export async function createFieldLead(body: FieldLeadCreate): Promise<FieldLeadRead> {
  return withDeadline(async (signal) => {
    const { data, error, response } = await api.POST("/field-leads", { body, signal });
    if (error || !data) {
      throw apiError(error, response, "No se pudo cargar el dato");
    }
    return data;
  });
}

export async function listFieldMachines(
  params: FieldMachineListParams = {},
): Promise<FieldMachinePage> {
  const { data, error, response } = await api.GET("/field-leads/machines", {
    params: { query: params },
  });
  if (error || !data) {
    throw apiError(error, response, "No se pudieron cargar las máquinas");
  }
  return data;
}
